import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import config from './config'
import 'firebase/compat/firestore'
firebase.initializeApp(config)

const auth = firebase.auth()
const db = firebase.firestore()

export {auth,db}